import Actions         from "../../../../model/constant/actions"
import ReducerUtils    from "../../../../utils/ReducerUtils"

const Retrieving = ReducerUtils.createReducer<boolean>(false,{
  [Actions.SAVING_RSA_ADCOPIES] : (state,action) => action.status
})

export default Retrieving
